import { Marker, SingleMapMarker } from 'components/map/Map';
import type { HubFE } from 'domain/hub';
import { toRioPosition } from 'helper/position';
import { memo, useMemo } from 'react';

interface HubMarkerProps {
    hub: HubFE;
}

// Hoisted to keep the reference stable across renders, like in VehicleMarker.
const FACTORY_ICON_NAMES = ['factory'];

/**
 * Hubs never move, so every `setGeometry`/`setIcon` UIKit performs here is wasted work.
 * Building the position object and the icon element inline meant new identities on every
 * render, and UIKit's Marker tracks both by identity — so each incoming vehicle update
 * re-pushed geometry and re-created the DOM node of every hub marker on the map.
 */
const HubComponent = ({ hub }: HubMarkerProps) => {
    const { lat, lng } = hub.position;

    const position = useMemo(() => toRioPosition({ lat, lng }), [lat, lng]);

    const icon = useMemo(
        () => (
            <SingleMapMarker
                clickable={false}
                name={hub.name}
                iconNames={FACTORY_ICON_NAMES}
                markerColor='bg-map-marker-poi'
            />
        ),
        [hub.name]
    );

    return <Marker customData={hub} position={position} icon={icon} />;
};

export default memo(HubComponent);
